import { Award, MapPin } from "lucide-react";
import { BRAND, IMAGES } from "../data/brand";

export default function About() {
  return (
    <section id="chi-siamo" data-testid="about-section" className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute top-20 right-0 w-96 h-96 bg-nexa-blue/5 rounded-full blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[4/5] overflow-hidden border border-white/10">
            <img
              src={IMAGES.beads}
              alt="Dettaglio nanotech - water beading"
              className="w-full h-full object-cover"
              data-testid="about-image"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6 border-l-2 border-nexa-blue pl-4">
              <div className="overline text-white">Tecnologia</div>
              <div className="heading text-2xl text-white mt-1">Effetto Idrorepellente</div>
            </div>
          </div>
          <div className="absolute -top-6 -right-6 w-32 h-32 border border-nexa-blue/50 hidden md:block" />
        </div>

        <div className="lg:col-span-7">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-px bg-nexa-blue" />
            <span className="overline">Chi Siamo</span>
          </div>

          <div className="heading text-3xl md:text-5xl text-white mb-8 leading-tight">
            Il <span className="text-nexa-blue">detailing mobile</span> che rispetta l'ambiente.
          </div>

          <div className="space-y-5 text-nexa-muted leading-relaxed text-base md:text-lg">
            <p>
              <span className="text-white font-semibold">NexaWash Studio</span> nasce a Rieti con un'idea semplice: portare il lavaggio professionale dove ti serve, senza sprecare una goccia d'acqua. Il nostro gazebo mobile trasforma ogni piazzale in uno studio di detailing.
            </p>
            <p>
              Utilizziamo una <span className="text-white">formula nanotech</span> composta da polimeri sigillanti, lubrificanti e agenti incapsulanti che sollevano lo sporco senza graffiare la carrozzeria. Il risultato è una pulizia profonda, una brillantezza immediata e una protezione duratura.
            </p>
            <p>
              Una scelta <span className="text-nexa-blue font-semibold">100% ecologica</span>: risparmio fino a 150 litri di acqua per ogni auto lavata.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-4 mt-10">
            <div className="card-surface p-5 flex items-start gap-4">
              <Award size={22} className="text-nexa-blue shrink-0 mt-0.5" />
              <div>
                <div className="heading text-white text-sm uppercase tracking-wider mb-1">Qualità Studio</div>
                <div className="text-xs text-nexa-muted">Prodotti professionali ad alta resa</div>
              </div>
            </div>
            <div className="card-surface p-5 flex items-start gap-4">
              <MapPin size={22} className="text-nexa-blue shrink-0 mt-0.5" />
              <div>
                <div className="heading text-white text-sm uppercase tracking-wider mb-1">Rieti &amp; Provincia</div>
                <div className="text-xs text-nexa-muted">{BRAND.address}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
